/* global env */
import { requestApi } from '../util/network'

export const getJoininOverview = () => requestApi('/Joinin/overview', 'POST')
export const getJoininGrades = () => requestApi('/Joinin/grades', 'POST')
export const sendJoininEmailCode = (email) => requestApi('/Joinin/email_captcha', 'POST', { email: email })
export const submitJoininApplication = (application, auth = '') => requestApi('/Joinin/apply', 'POST', application, auth)
export const getJoininApplication = () => requestApi('/Joinin/get_info', 'POST', {}, 'member')
export const getJoininPaymentPdfUrl = (token) => env.API_HOST + '/Joinin/export_payment_pdf?key=' + encodeURIComponent(token)
